<template>
    <div class="p-3">
        <div class="row">
            <div class="col-md-12">
                <h5>{{transEdit('remove-availability')}}</h5>
                <hr>

                <div class="mt-1 form-group row">
                    <div class="col-2">{{transEdit('date')}}: </div>
                    <div class="col-10"><strong>{{getDate(availability.start)}}</strong></div>
                </div>

                <div class="mt-1 form-group row">
                    <div class="col-2">{{transEdit('time')}}: </div>
                    <div class="col-10"><strong>{{getTime(availability.start)}} - {{getTime(availability.end)}}</strong></div>

                </div>

                <hr>
                <div>
                    <button class="btn btn-danger" @click="deleteAvailability"><i class="fa fa-minus"></i> {{transEdit('remove-availability')}}</button>
                    <button class="btn btn-dark" @click="closeModal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

    export default {
        name: "DeleteAvailabilityModal",
        props: ['availability', 'route_delete'],
        methods: {
            getDate(dateString){
                return moment(dateString).format('YYYY-MM-DD');
            },
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' +  moment(dateString).format('HH:mm');
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm');
            },
            getTimespanSameDate(start, end) {
                let _start = moment(start);
                let _end = moment(end);
                return _start.format('YYYY-MM-DD') + ', ' + _start.format('HH:mm') + ' - ' + _end.format('HH:mm');
            },
            closeModal() {
                this.$emit('close');
            },
            deleteAvailability() {
                let self = this;
                let data = {id: this.availability.id};
                axios.delete(this.route_delete + "/" + this.availability.id, {
                    data: data
                })
                .then(function (response) {
                    if (response.data.error) {
                        Vue.toasted.error('Kunde ej radera tillgänglighet');
                        self.closeModal();
                    } else {
                        Vue.toasted.success(this.trandEdit('availability-removed'));
                        self.closeModal();
                    }
                })
                .catch(function (error) {
                });
            },
        }
    }
</script>

<style scoped>

</style>
